import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


import Index from '@/views/Index'

export const constantRoutes = [
    {
      path: "/login",
      component: () => import('@/views/Login'),
      hidden: true
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/purchaseRegister',
      name: "purchaseRegister",
      component: () => import('@/views/purchase-register.vue'),
      hidden: true
    },
    {
      path: '/supplierRegister',
      name: "supplierRegister",
      component: () => import('@/views/supplier-register.vue'),
      hidden: true
    },
    {
      path: '/rukudan',
      name: "rukudan",
      component: () => import('@/views/print/rukudan'),
      hidden: true
    },
  {
    path: '/chukudan',
    name: "chukudan",
    component: () => import('@/views/print/chukudan'),
    hidden: true
  },
  {
    path: '/purchase-order-print',
    name: "PurchaseOrderPrint",
    component: () => import('@/views/business/order/check/purchaseOrder/purchaseOrder-print'),
    hidden: true
  },
  {
    path: '/sort-order-print',
    name: "SortOrderPrint",
    component: () => import('@/views/business/order/check/sortOrder/sortOrder-print'),
    hidden: true
  },
  {
    path: '/inspection-order-print',
    name: "InspectionOrderPrint",
    component: () => import('@/views/business/order/check/inspectionOrder/inspectionOrder-print'),
    hidden: true
  },
  {
    path: '/sign-for-print',
    name: "SignForPrint",
    component: () => import('@/views/business/order/check/signFor/signFor-print'),
    hidden: true
  },
  {
    path: '/store-change-enter-print',
    name: "StoreChangeEnterPrint",
    component: () => import('@/views/wms/business/storeChangeEnter/storeChangeEnter-print'),
    hidden: true
  },
  {
    path: '/store-change-out-print',
    name: "StoreChangeOutPrint",
    component: () => import('@/views/wms/business/storeChangeOut/storeChangeOut-print'),
    hidden: true
  },
  {
    path: '/process-purchase-print',
    name: "ProcessPurchasePrint",
    component: () => import('@/views/business/order/processOrder/process-purchase-print'),
    hidden: true
  },
  {
    path: '/purchase-order-entry',
    name: "PurchaseOrderEntry",
    component: () => import('@/views/business/order/check/purchaseOrder/purchaseOrder-entry'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/home',
    component: Index,
    children: [
      {
        path: "/home",
        name: '公卫管理系统',
        component: () => import('@/views/Home'),
        meta:{
          title: '首页'
        }
      },
      {
        path: "/user-edit",
        name:'用户管理',
        component: () => import('@/views/sys/user/user-edit'),
        meta: {
          title: '编辑用户信息',
          menu: true,
          topName:'system-setting',
          parentMenuName: '用户管理'
        }
      },
      {
        path: "/user-permission-supplier",
        name:'用户管理',
        component: () => import('@/views/sys/user/user-permission-supplier'),
        meta: {
          title: '授权供应商',
          menu: true,
          topName:'system-setting',
          parentMenuName: '用户管理'
        }
      },
      {
        path: "/sys-company-edit",
        name:'编辑使用单位',
        component: () => import('@/views/sys/purchase/purchase-add'),
        meta: {
          title: '编辑使用单位',
          menu: true,
          topName:'sys-company-list',
          parentMenuName: '使用单位'
        }
      },
      {
        path: '/goodsCategory-add',
        name:'新增商品品类',
        component: () => import('@/views/business/goods/goodsCategory/goodsCategory-add'),
        meta: {
          title: '新增商品品类',
          menu: true,
          topName:'business-goods',
          parentMenuName: '品类管理列表'
        }
      },
      {
        path: '/goodsCategory-edit',
        name:'修改品类',
        component: () => import('@/views/business/goods/goodsCategory/goodsCategory-edit'),
        meta: {
          title: '修改品类',
          menu: true,
          topName:'business-goods',
          parentMenuName: '品类管理列表'
        },
      },
      {
        path: '/order_detail',
        component: () => import('@/views/business/order/common/order-view'),
        meta: {
          title: '订单详情',
          menu: true,
          topName:'cgManage',
          parentMenuName: '订单'
        },
      },
      {
        path: '/purchaseOrder_detail',
        component: () => import('@/views/business/order/check/purchaseOrder/purchaseOrder-info'),
        meta: {
          title: '采购单详情',
          menu: true,
          topName:'suppier',
          parentMenuName: '采购&验货'
        }
      },
      {
        path: '/followOrder_detail',
        component: () => import('@/views/business/order/common/followOrder-info'),
        meta: {
          title: '验货单详情',
          menu: true,
          topName:'suppier',
          parentMenuName: '采购&验货'
        }
      },
      {
        path:'/createPurchaseOrder',
        component: () => import('@/views/business/order/common/order-createPurchaseOrder'),
        meta: {
          title: '生成采购单、验货单',
          menu: true,
          topName:'suppier',
          parentMenuName: '采购&验货'
        }
      },
      {
        path:'/order-signFor-detail',
        component: () => import('@/views/business/order/check/signFor/signFor-sign'),
        meta: {
          title: '签收验货单',
          menu: true,
          topName:'order-sign',
          parentMenuName: '签收'
        }
      },
      {
        path:'/order-signFor-data-detail',
        component: () => import('@/views/business/order/check/signFor/signFor-sign-detail'),
        meta: {
          title: '签收明细',
          menu: true,
          topName:'order-sign',
          parentMenuName: '签收'
        }
      },
      {
        path:'/sort-order',
        component: () => import('@/views/business/order/check/purchaseOrder/purchase-sortOrder-list'),
        meta: {
          title: '分拣',
          menu: true,
          topName:'suppier',
          parentMenuName: '采购&验货'
        }
      },
      {
        path:'/goods_trace_detail',
        component: () => import('@/views/business/goods/goods/goods-transaction'),
        meta: {
          title: '商品追溯详情',
          menu: true,
          topName:'cgManage',
          parentMenuName: '订单'
        }
      },
      {
        path:'/ultra-order-add',
        component: () => import('@/views/sys/ultra/order/ultra-order-add'),
        meta: {
          title: '超限订单维护',
          menu: true,
          topName:'super',
          parentMenuName: '超限功能'
        }
      },
      {
        path:'/ultra_order_detail',
        component: () => import('@/views/sys/ultra/order/ultra-order-detail'),
        meta: {
          title: '超限订单维护',
          menu: true,
          topName:'super',
          parentMenuName: '超限功能'
        }
      }



    ]
  },

]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js